import Vue from 'vue'
import Vuex from 'vuex'
import DivisionMasterProvider, { DivisionMasterModel } from '@/provider/divisionMaster'

Vue.use(Vuex)

const MANAGER_TYPE = 'manager'
const ASSISTANT_TYPE = 'assistant'

export default new Vuex.Store({
  state: {
    user: {},
    adminType: '',
    divisionMaster: [] as Array<DivisionMasterModel>,
    divisionMasterLoaded: false,
    currentDivision: new DivisionMasterModel(),
    currentSearchRewardStatus: ''
  },
  mutations: {
    setUser: (state, user) => {
      console.log('Store - Set user', user)
      const userDivision = user.attributes['custom:division']
      if (userDivision) {
        console.log('user division', userDivision)
        if (state.currentDivision.id !== userDivision) {
          const division = state.divisionMaster.find((e) => e.id === userDivision)
          if (division) {
            state.currentDivision = division
            localStorage.setItem('currentDivisionId', state.currentDivision.id)
          }
        }
      }
      state.user = user
    },
    setAdminType: (state, adminType) => {
      console.log('Store - Set adminType')
      state.adminType = adminType
    },
    setDivisionMaster: (state, divisionMaster) => {
      console.log('Store - Set divisionMaster')
      state.divisionMasterLoaded = true
      state.divisionMaster = divisionMaster
      if (!state.currentDivision.id) {
        const currentDivisionId = localStorage.getItem('currentDivisionId')
        console.log('localStorage currentDivisionId ', currentDivisionId)
        if (currentDivisionId) {
          const division = state.divisionMaster.find((e) => {
            return e.id === currentDivisionId
          })
          if (division) {
            state.currentDivision = division
          }
        } else {
          if (state.divisionMaster.length > 0) {
            state.currentDivision = state.divisionMaster[0]
          }
        }
        if (state.currentDivision.id) {
          localStorage.setItem('currentDivisionId', state.currentDivision.id)
        }
        console.log('state currentDivision id ', state.currentDivision.id)
      }
    },
    setCurrentDivision: (state, divisionId) => {
      console.log('Store - Set currentDivision')
      const division = state.divisionMaster.find((e) => {
        return e.id === divisionId
      })
      if (division) {
        state.currentDivision = division
        localStorage.setItem('currentDivisionId', state.currentDivision.id)
      }
    },
    setCurrentSearchRewardStatus: (state, currentSearchRewardStatus) => {
      console.log('Store - Set currentSearchRewardStatus')
      state.currentSearchRewardStatus = currentSearchRewardStatus
    }
  },
  actions: {
    loadDivisionMaster: async (context) => {
      const provider = new DivisionMasterProvider()
      context.commit('setDivisionMaster', await provider.load())
    }
  },
  getters: {
    user: (state, getters) => {
      return state.user
    },
    adminType: (state, getters) => {
      return state.adminType
    },
    isValidAdminType: (state, getters) => (adminType: string) => {
      if (adminType === MANAGER_TYPE) {
        return true
      }
      if (adminType === ASSISTANT_TYPE) {
        return true
      }
    },
    divisionMaster: (state, getters) => {
      return state.divisionMaster
    },
    divisionMasterLoaded: (state, getters) => {
      return state.divisionMasterLoaded
    },
    currentDivision: (state, getters) => {
      return state.currentDivision
    },
    currentSearchRewardStatus: (state, getters) => {
      return state.currentSearchRewardStatus
    },
    isManager: (state, getters) => {
      return getters.adminType === 'manager'
    }
  }
})
